export const sliderConfig = {
    container: '.base-full-carouselStepsContainer',
    slideBy: 'page',
    autoplay: false,
    center: false,
    swipeAngle: false,
    loop: false,
    gutter: 0,
    controls: false,
    touch: false,
    nav: false,
    edgePadding: 0
}
